/* Unbroken Vine — gift with purchase.

   The book carries three gifts: the Orthodox prayer bracelet and the two
   e-guides. All three are separate 0.00 listings. That is deliberate: a Buy X
   Get Y discount was tried first and cannot work here, because Shopify applies
   only ONE automatic discount per order, so the existing buy2 / buy3 volume
   discounts suppressed it the moment a shopper ordered more than one copy.
   Priced at zero, the gifts are free at every quantity and depend on nothing.

   Rules this file lives by, learned the hard way:
     - it NEVER touches the book line, only the three gift lines
     - it NEVER reloads the page; an earlier version did, and on the cart page
       that raced the theme's own remove request and made the book impossible
       to delete
     - it gives up after a few passes, so a failing write can never loop
   main.js is minified past the point of being safe to hook, so nothing here
   depends on the theme's cart internals and every failure leaves the cart
   exactly as the shopper left it. */
(function () {
  'use strict';

  var BOOK = 48325500666068;
  var GIFTS = [
    { id: 48600185110740, perBook: true,  max: 0 }, // bracelet: one per copy, no ceiling
    { id: 48600152342740, perBook: false, max: 1 }, // Your First Sunday
    { id: 48600152375508, perBook: false, max: 1 }  // Your Icon Corner
  ];

  var busy = false;
  var passes = 0;
  var MAX_PASSES = 6;   // a hard stop: no sequence of events can spin this forever

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  /* max === 0 means "no ceiling": a per-book gift then tracks the book quantity
     exactly, so five copies bring five bracelets. */
  function wanted(bookQty, gift) {
    if (bookQty < 1) return 0;
    if (!gift.perBook) return gift.max;
    return gift.max > 0 ? Math.min(bookQty, gift.max) : bookQty;
  }

  function reconcile() {
    if (busy || passes >= MAX_PASSES) return Promise.resolve(false);
    busy = true;
    passes++;
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var have = {};
        cart.items.forEach(function (i) { have[i.variant_id] = i.quantity; });
        var bookQty = have[BOOK] || 0;

        var add = [], updates = {};
        GIFTS.forEach(function (g) {
          var want = wanted(bookQty, g), got = have[g.id] || 0;
          if (want === got) return;
          if (got === 0) add.push({ id: g.id, quantity: want });
          else updates[g.id] = want;            // quantity 0 removes the line
        });
        if (!add.length && !Object.keys(updates).length) return false;

        /* Removals go first. If the shopper has just deleted the book, clearing
           the now-unfree bracelet matters more than adding anything. */
        var step = Promise.resolve();
        if (Object.keys(updates).length) step = step.then(function () { return post('/cart/update.js', { updates: updates }); });
        if (add.length) step = step.then(function () { return post('/cart/add.js', { items: add }); });
        return step.then(function () { return true; });
      })
      .catch(function () {
        passes = MAX_PASSES;                    // a failed write must not be retried in a loop
        return false;
      })
      .then(function (changed) {
        busy = false;
        if (changed) {
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
        }
        return changed;
      });
  }

  /* Themes post add-to-cart as JSON, FormData or urlencoded. Read all three.
     Returns the line items AND the section-rendering fields: this theme asks for
     `sections=cart-drawer,cart-icon-bubble` so it can redraw the drawer from the
     response. Dropping them is why an earlier version added the gifts correctly
     server-side while the shopper saw nothing happen at all. */
  function readAdd(body) {
    try {
      if (!body) return null;
      var items = null, sections = null, sectionsUrl = null;

      if (typeof body === 'string') {
        if (body.charAt(0) === '{') {
          var o = JSON.parse(body);
          sections = o.sections || null;
          sectionsUrl = o.sections_url || null;
          if (o.items) {
            items = o.items.map(function (i) {
              return { id: Number(i.id), quantity: Number(i.quantity) || 1 };
            });
          } else if (o.id) {
            items = [{ id: Number(o.id), quantity: Number(o.quantity) || 1 }];
          }
        } else {
          var p = new URLSearchParams(body);
          sections = p.get('sections');
          sectionsUrl = p.get('sections_url');
          if (p.get('id')) items = [{ id: Number(p.get('id')), quantity: Number(p.get('quantity')) || 1 }];
        }
      } else if (typeof FormData !== 'undefined' && body instanceof FormData) {
        sections = body.get('sections');
        sectionsUrl = body.get('sections_url');
        if (body.get('id')) {
          items = [{ id: Number(body.get('id')), quantity: Number(body.get('quantity')) || 1 }];
        }
      }

      if (!items) return null;
      return { items: items, sections: sections, sectionsUrl: sectionsUrl };
    } catch (e) { return null; }
  }

  /* Read a /cart/change.js or /cart/update.js body. Returns {id|line, quantity}
     for a single-line change, or null for anything more complicated. */
  function readChange(body) {
    try {
      if (!body || typeof body !== 'string') return null;
      var o = body.charAt(0) === '{' ? JSON.parse(body) : null;
      if (!o) {
        var p = new URLSearchParams(body);
        if (p.get('quantity') === null) return null;
        o = { id: p.get('id'), line: p.get('line'), quantity: Number(p.get('quantity')) };
      }
      if (o.updates) return null;               // a bulk update is not ours to rewrite
      if (typeof o.quantity === 'undefined') return null;
      return { id: o.id, line: Number(o.line) || 0, quantity: Number(o.quantity) };
    } catch (e) { return null; }
  }

  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    var args = arguments;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var opts = init || {};
    var method = (opts.method || (input && input.method) || 'GET').toUpperCase();

    /* Send the book and its gifts as ONE request, so the theme's cart drawer
       already has the gifts when it renders from the response. */
    if (!busy && method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      var parsed = readAdd(opts.body);
      var items = parsed && parsed.items;
      var book = items && items.filter(function (i) { return i.id === BOOK; })[0];
      if (book) {
        /* The cart renders newest line first, so the gifts are sent BEFORE the
           book and in reverse: the book then sits at the top with its three
           gifts tucked underneath, which is what makes the group read as a
           bundle rather than as four separate purchases. */
        var merged = [];
        GIFTS.slice().reverse().forEach(function (g) {
          var already = items.some(function (i) { return i.id === g.id; });
          if (!already) merged.push({ id: g.id, quantity: wanted(book.quantity, g) });
        });
        merged = merged.concat(items);

        var payload = { items: merged };
        /* hand back the same sections the theme asked for, or its drawer has
           nothing to render and the click looks like it did nothing */
        if (parsed.sections) payload.sections = parsed.sections;
        if (parsed.sectionsUrl) payload.sections_url = parsed.sectionsUrl;

        return nativeFetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
      }
    }

    /* The shopper changing the BOOK line is the important case. Rewriting it as a
       single /cart/update.js that also corrects the gifts means the theme renders
       the finished cart from its own response: no second request, nothing stale on
       screen, and no reload racing the request the shopper just made. */
    if (!busy && method === 'POST' && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      var change = readChange(opts.body);
      if (change) {
        busy = true;
        return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var target = change.id;
            if (!target && change.line) {
              var line = cart.items[change.line - 1];
              target = line && line.variant_id;
            }
            if (Number(target) !== BOOK) throw 'not-the-book';

            var updates = {};
            updates[BOOK] = change.quantity;
            GIFTS.forEach(function (g) { updates[g.id] = wanted(change.quantity, g); });
            return nativeFetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .then(function (res) { busy = false; return res; })
          .catch(function () {
            busy = false;                       // anything unexpected: let the original stand
            return nativeFetch.apply(null, args);
          });
      }
    }

    var out = nativeFetch.apply(this, arguments);

    /* Any other cart write can strand a gift behind a removed book. Wait for the
       theme to finish its own re-render before touching anything, so we are
       never racing the request the shopper actually made. */
    if (!busy && method === 'POST' && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
      try { out.then(function () { setTimeout(reconcile, 500); }).catch(function () {}); } catch (e) {}
    }
    return out;
  };


  /* ---- "2x" in front of a gift that arrives more than once ----------------
     The count lives in the row's data-quantity attribute. CSS cannot reach it:
     attr() only reads the element the pseudo is attached to, never a parent. So
     the prefix is written into the DOM instead, and re-applied whenever the
     theme redraws the cart, which it does from scratch on every change. */
  var GIFT_HANDLES = ['orthodox-bracelet-free-gift',
                      'your-first-sunday-e-guide',
                      'your-icon-corner-e-guide'];

  function decorate() {
    try {
      GIFT_HANDLES.forEach(function (h) {
        var rows = document.querySelectorAll('.cart-item--product-' + h);
        Array.prototype.forEach.call(rows, function (row) {
          var name = row.querySelector('.cart-item__name');
          if (!name) return;
          var qty = parseInt(row.getAttribute('data-quantity') || '1', 10);
          var base = name.getAttribute('data-gwp-title');
          if (base === null) {
            base = name.textContent.trim();
            name.setAttribute('data-gwp-title', base);
          }
          var wanted = qty > 1 ? qty + '\u00d7 ' + base : base;
          if (name.textContent.trim() !== wanted) name.textContent = wanted;
        });
      });
    } catch (e) {}
  }

  /* The drawer replaces its markup wholesale, so a one-off pass would be undone
     by the next redraw. Watch for those redraws and re-apply. */
  function watch() {
    decorate();
    try {
      var mo = new MutationObserver(function () {
        if (watch._t) clearTimeout(watch._t);
        watch._t = setTimeout(decorate, 40);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* Safety net for carts built by form posts, XHR, or an earlier session. */
  function flag(v) {
    try { return v === undefined ? sessionStorage.getItem('uv_gwp_reloaded')
                                 : (v === null ? sessionStorage.removeItem('uv_gwp_reloaded')
                                               : sessionStorage.setItem('uv_gwp_reloaded', v)); }
    catch (e) { return null; }
  }

  function firstPass() {
    reconcile().then(function (changed) {
      /* The page-load pass may find a cart left stale by an earlier session and
         correct it, in which case the rendered HTML is already wrong and a reload
         is the honest fix. At page load nothing is in flight, so it cannot race a
         shopper's request. The flag is armed BEFORE reloading and only cleared on
         a load that changed nothing, which is what makes a loop impossible. */
      if (!changed) { flag(null); return; }
      if (flag()) return;
      flag('1');
      window.location.reload();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { firstPass(); watch(); });
  } else {
    firstPass();
    watch();
  }
})();
